export const links = {
  customerUrl: process.env.REACT_APP_CUSTOMER_URL || 'https://dev.optimalnetworkintegration.net',
  adminUrl: process.env.REACT_APP_ADMIN_URL || 'https://devadmin.optimalnetworkintegration.net',
  siteUrl: process.env.REACT_APP_SITE_URL || 'https://optimalnetworkintegration.net',
  venueColor: process.env.REACT_APP_VENUE_COLOR || '#B10202',
  demoApiUrl: process.env.REACT_APP_DEMO_API_URL || '/api/demo-request',
} as const;

export const routes = {
  home: '/',
  features: '/features',
  howItWorks: '/how-it-works',
  technology: '/technology',
  solutions: '/solutions/stadiums-arenas',
  solutionsConcertVenues: '/solutions/concert-venues',
  about: '/about',
  requestDemo: '/request-demo',
} as const;

export const homeSections = {
  howItWorks: 'how-it-works',
  features: 'features',
  technology: 'technology',
  faq: 'faq',
} as const;

export const externalLinkProps = {
  target: '_blank' as const,
  rel: 'noopener noreferrer',
};
